<template>
  <section class="fold-wrapper">
    <div :class="classNames" @click="clickFold">
      <VP class="title" :text="title" :size="size" :weight="defaultWeight" :color="fontColor" />
      <div class="icon-wrapper">
        <img :src="foldIcon" class="icon" :style="rotateIcon" />
      </div>
    </div>
    <div v-show="!fold" class="contents">
      <slot></slot>
    </div>
  </section>
</template>

<script>
import VP, { TextColor, TextWeight } from '@/presentationals/v2/components/layouts/atoms/VP'

export const ColorType = Object.freeze({
  none: 'transparent',
  brand: 'brand-background',
  gray: 'gray-background',
  white: 'white-background'
})

export const FoldTextColor = Object.freeze(TextColor)

export const FoldTextWeight = Object.freeze(TextWeight)

import foldIcon from '@/assets/images/fold-icon.svg'

export default {
  name: 'VFold',
  props: {
    title: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: ColorType.white
    },
    fontColor: {
      type: String,
      default: TextColor.black
    },
    size: {
      type: Number,
      default: 21
    },
    defaultState: {
      type: Boolean,
      default: false
    },
    defaultWeight: {
      type: String,
      default: TextWeight.bold
    }
  },
  computed: {
    rotateIcon() {
      return {
        transform: `rotate(${this.fold ? '0' : '180deg'})`
      }
    },
    classNames() {
      return ['fold-header', this.color]
    }
  },
  methods: {
    clickFold() {
      this.fold = !this.fold
    }
  },
  components: {
    VP
  },
  data() {
    return {
      TextWeight,
      foldIcon,

      fold: this.defaultState
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.fold-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  box-sizing: border-box;

  .fold-header {
    display: flex;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    align-items: center;
    padding: 16px 16px 0 16px;

    .title {
      display: block;
      width: 100%;
      text-align: left;

      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      letter-spacing: -0.3px;
    }

    .icon-wrapper {
      width: 24px;
      height: 24px;

      .icon {
        width: 24px;
        height: 24px;
      }
    }
  }

  .contents {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    background-color: $background-gray;
  }
}

.transparent {
  background-color: transparent;
}

.brand-background {
  background-color: $brand;
}

.gray-background {
  background-color: $background-gray;
}

.white-background {
  background-color: $background-white;
}
</style>